<template>
  <div id="home">

    <main class="main index">

      <div class="bannerSlider">
          <ul class="titleBanner">
            <li v-for = "banners in bannersList" :key="banners.id">
              <!-- <a href="" @click="bannerClick(banners)"> <img v-bind:src="banners.imgBanner" ></a> -->
              <a :href="banners.action" target="_blank"><img v-bind:src="banners.imgBanner"  @click="gaClick ('首頁 banner',banners.title)"  ></a>
            </li>
          </ul>
      </div>

      <div v-if=" this.beltsList.length > 0 " class="marqueeContainer">
        <div class="wrap" >
          <ul>

            <li v-for = "belts in beltsList" :key="belts.id">
              <div class="singmarq" >
                <a :href=" pageUrl+'news/'+belts.id" target="_blank"  @click="gaClick ('首頁腰帶',belts.title)"  >
                  {{belts.title}}
                </a>
              </div>
            </li>

          </ul>
          <router-link to="/news/list" class="more">更多<span>消息</span></router-link>
        </div>
      </div>

      <div id="trigger" class="section mainGraphic">
        <div class="container-fluid">
          <h2>好知識就在耳邊</h2>
          <p>運用零碎時間，達到系統學習<br>時時刻刻。精選一課</p>
          <figure id="mainGraphic" class="unit_mainGraphic"></figure><!--視覺圖-->
        </div>
      </div>

      <div class="section merit">
        <div class="container">
          <div class="row justify-content-md-center">
            <div class="col-md-4 col-lg-3">
              <h3>打開你的耳朵</h3>
              <p>15分鐘，隨挑隨選，打開知識大門。</p>
            </div>
            <div class="col-md-4 col-lg-3">
              <h3>顛覆你的大腦</h3>
              <p>拿掉複雜文字，深入淺出，用聆聽顛覆傳統閱讀。</p>
            </div>
            <div class="col-md-4 col-lg-3">
              <h3>移動你的教室</h3>
              <p>不受空間限制，打破場地框架，立即敲響上課鐘聲。</p>
            </div>
          </div>
          <!-- <a class="more" href="#">新手上路</a> -->
        </div>
          <!--視差背景-->
        <div id="parallax1" class="parallaxParent"><div></div></div>
      </div>

      <div class="section mainContent">
        <div class="container">

          <h2 v-if="this.blocks[0] && this.blocks[0].title">{{this.blocks[0].title}}</h2>
          <p v-if="this.blocks[0] && this.blocks[0].description">{{this.blocks[0].description}}</p>
          <ul v-if="this.channels1[0]" class="slick_list course">
            <li v-for = "(channels,$index) in channels1" :key="channels.id"  @click="channelClickListener (channels, $index)"   >
              <figure>
                <div class="graphic">
                  <img v-bind:src="channels.imgCover" >
                </div>
              </figure>
              <figcaption>
                <b>{{channels.category.title}} </b><!--課程分類-->
                <h3>{{channels.title}}</h3><!--課程名稱-->
              </figcaption>
              <router-link v-bind:to="'/channel/'+channels.id" class="fullLink"></router-link>

              <!-- <a href="course.html" class="fullLink" title="寶寶怎麼養才好">詳細內容</a> -->
            </li>

          </ul>
          <router-link to="/channel/list" class="more">看全部課程</router-link>

          <h2 v-if="this.blocks[1] && this.blocks[1].title">{{this.blocks[1].title}}</h2>
          <p v-if="this.blocks[1] && this.blocks[1].description">{{this.blocks[1].description}}</p>
          <ul v-if="this.channels2[0]" class="slick_list tutor">
            <li v-for = "(channels,$index) in channels2" :key="channels.id" @click="channelClickListener (channels, $index)" >
              <figure>
                <div class="graphic">
                  <img v-bind:src="channels.author.imgAvatar" >
                </div>
              </figure>
              <figcaption>
                <h3>{{channels.author.title}}</h3>
                <p v-html = substring(channels.author.description)></p>
              </figcaption>
              <router-link v-bind:to="'/channel/'+channels.id"> <a :href="'/channel/'+channels.id" class="fullLink"></a></router-link>
              <!-- <a href="course.html" class="fullLink" title="寶寶怎麼養才好">詳細內容</a> -->
            </li>
          </ul>
          <router-link to="/author/list"><a a class="more" >看全部大師</a></router-link>

        </div>
      </div>

    </main>
    <!-- footer -->
  </div>

</template>

<script>
/* eslint-disable no-undef */
// slick
// eslint-disable-next-line no-unused-vars
import slick from '@/assets/vendor/slick/slick.min.js'
// pace
// eslint-disable-next-line no-unused-vars
import pace from '@/assets/vendor/pace/js/pace.min.js'
// 首頁專用function
// eslint-disable-next-line no-unused-vars
import functionJs from '@/assets/js/function_index.js'

// eslint-disable-next-line no-unused-vars
import marquee from '@/assets/vendor/marquee/jquery.marquee.min.js'

// import inewsticker from "@/assets/js/inewsticker.js";

// eslint-disable-next-line no-unused-vars
import simpleTicker from '@/assets/vendor//simpleTicker/jquery.simpleTicker.js'

export default {

  name: 'async',
  // metaInfo () {
  //   return {
  //     title: '一刻鯨選：好知識就在耳邊',
  //     meta: [

  //       // OpenGraph data (Most widely used)
  //       { property: 'og:title', content: '一刻鯨選：好知識就在耳邊' },
  //       { property: 'og:site_name', content: '一刻鯨選：好知識就在耳邊' },
  //       // The list of types is available here: http://ogp.me/#types
  //       { property: 'og:type', content: 'website' },
  //       // Should the the same as your canonical link, see below.
  //       // { property: 'og:url', content: window.location.toString() },
  //       { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
  //       // Often the same as your meta description, but not always.
  //       { property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！' }

  //     ]
  //   }
  // },

  data () {
    return {

      loaders: ['a', 'c', 'b', 'a', 'b', 'a', 'c', 'a', 'c', 'a', 'b'],

      homeData: [],
      bannersList: [],
      blocks: [],
      channels1: [], // 鯨選課堂
      channels2: [], // 鯨選大師
      beltsList: [],
      pageUrl: ''
    }
  },

  created () {
    this.pageUrl = window.location.toString()
    if (this.pageUrl.includes('testfront')) {
      this.pageUrl = 'https://testfront.jinfm.net/'
    } else if (this.pageUrl.includes('temp')) {
      this.pageUrl = 'https://tempfront.jinfm.net/'
    } else {
      this.pageUrl = 'https://jinfm.net/'
    }
    this.axios
      .get(this.$store.getters.baseURL + 'home')
      .then(response => {
        this.homeData = response.data
        this.bannersList = this.homeData.banners
        this.blocks = this.homeData.blocks
        this.channels1 = this.blocks[0].channels
        this.channels2 = this.blocks[1].channels
        this.axios
          .get(this.$store.getters.baseURL + 'announcements')
          .then(response => {
            this.beltsList = response.data
          })
          .catch(error => console.log('log:' + error))
      })
      .catch(error => console.log('log:' + error))
  },
  updated () {
    //  $(document).ready(function() {
    //     $('.marqueeContainer ul').inewsticker({
    //           speed: 4500,
    //           effect: 'fade',
    //           dir: 'ltr',
    //           delay_after: 1000
    //         });
    //     });

    $(document).ready(function () {
      $.simpleTicker($('.marqueeContainer .wrap'), { effectType: 'fade' })
    })

    $('.titleBanner').not('.slick-initialized').slick({
      centerMode: true,
      slidesToShow: 2,
      variableWidth: true,
      speed: 900,
      dots: true,
      loop: true,
      infinite: true,
      autoplay: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            adaptiveHeight: true
          }
        }
      ]
    })
    $('.slick_list.course').not('.slick-initialized').slick({
      infinite: true,
      arrows: true,
      loop: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 767,
          settings: 'unslick'
          // settings: {
          //   infinite: false,
          //   arrows: false,
          //   slidesToShow: 2,
          //   slidesToScroll: 1,
          //   variableWidth: true

          // }
        }
      ]
    })

    $('body').addClass('index')

    $('.slick_list.tutor').not('.slick-initialized').slick({
      infinite: true,
      arrows: true,
      loop: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 767,
          settings: 'unslick'
          // settings: {
          //   infinite: false,
          //   arrows: false,
          //   slidesToShow: 2,
          //   slidesToScroll: 1,
          //   variableWidth: true
          // }
        }
      ]
    })

    $('#pagetop p').click(function () {
      $('html,body').animate({ scrollTop: 0 }, 'slow')
      return false
    })
  },

  methods: {

    // bannerClick(item) {
    //     alert(item);
    //   window.open(item.action);

    // },

    gaClick (action, title) {
      this.$ga.event({
        eventCategory: '行銷',
        eventAction: action,
        eventLabel: title
        // eventValue: 123
      })
    },

    channelClickListener (item, index) {
      // alert(item.id);
      const id = item.id
      // this.$router.push({ path: "/course" });
      this.metaInfo = []
      // this.$store.commit('courseId', id)
      this.$router.push({ path: '/channel/' + id, params: { id } })
    },
    substring: function (arr) {
      var index = arr.indexOf('\n')
      arr = arr.substring(0, index)
      arr = arr.replace('●　', '')
      return arr
    }

  }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue